'use client'

import { useQuery } from '@tanstack/react-query'
import { useSession } from './useSession'

/**
 * Hook to check if the current user has linked their Discord account.
 * Returns linked status and Discord username.
 */
export function useDiscordStatus() {
  const { user, loading: userLoading } = useSession()

  const { data, isLoading } = useQuery({
    queryKey: ['discord-status', user?.id],
    queryFn: async () => {
      const res = await fetch('/api/auth/discord/status')
      if (!res.ok) return { linked: false }
      return res.json()
    },
    enabled: !userLoading && !!user,
    staleTime: 5 * 60 * 1000,
  })

  return {
    linked: data?.linked ?? false,
    username: data?.username as string | undefined,
    loading: userLoading || isLoading,
  }
}
